<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'风险评估'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">风险评估</p>
			<p class="t-align-center serviceT mt-10 mb-20">Risk assessment</p>
			<div class="m-0auto maxw-1400 dp-f justify-between pb-50">
				<div>
					<p class="fz-24 f-blue line-50 f-bold">风险评估意义</p>
					<p class="t-indent2 line-26 fz-18">风险评估是从风险管理角度，运用科学的方法和手段系统地分析相关系统所面临的威胁及其存在的脆弱性，评估安全事件一旦发生可能造成的危害程度，提出有针对性的应对威胁的防护策略和整改措施。有效防范和化解信息安全风险，最大限度地防止由于相关系统安全事件引发安安全事故，全面提供相关系统安全防护水平。</p>
					<img src="../../assets/img/service/u27.png" alt="">
					<img src="../../assets/img/service/u28.png" alt="">
				</div>
				<div>
					<div class="bg-blue t-align-center">
						<p class="fz-24 f-white f-bold">风险评估流程</p>
					</div>
					<div class="li-w">
						<li>识别信息系统的应用和业务，业务所涉及资产；</li>
						<li>对信息资产进行识别，并对资产赋值；</li>
						<li>识别信息资产的脆弱性（弱点/漏洞），并对弱点的严重程度赋值；</li>
						<li>对威胁进行分析，并对威胁发生的可能性赋值；</li>
						<li>综合分析当前具备的安全措施及其作用；</li>
						<li>综合分析资产价值、资产的脆弱性和威胁发生的可能性，得到信息资产的风险发生的路径和级别，并对风险进行处置，选择合适的控制措施；</li>
						<li>综合评定应用和业务的安全性；</li>
						<li>给出安全建议、安全管理体系建设服务。</li>
					</div>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
.maxw-1400>div{
	width: 48%;
}
.maxw-1400>div:first-child img{
	width: 100%;
	margin-top: 30px;
}
.maxw-1400>div:last-child{
	background-color: #effffc;
	height: inherit;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.bg-blue{
	background-color: #4264b5;
	height: 60px;
	line-height: 60px;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.li-w{
	padding: 30px;
	font-size: 18px;
	height: 96%;
	line-height: 300%;
	letter-spacing: 0.1em;
	color: #808080;
	display: flex;
	flex-direction: column;
}
li::marker{
	color: #4264b5;
	font-size: 2rem;
}
</style>